import 'pixi-layers'
import Stage = PIXI.display.Stage
import Group = PIXI.display.Group
import Layer = PIXI.display.Layer

import Container = PIXI.Container
import * as log from "./utils/log";

declare var DEBUG

class layerGroup {
    index: number
    name: string
    pixiGroup: Group
    layer: Layer
}

@log.decoratorConfig({isEnabled: DEBUG, isStylized: true})
class LayerManagerClass {
    warn

    private static instance: LayerManagerClass
    private _stage: Stage
    private groupIndex: number
    private groups: Array<layerGroup>

    private constructor() {
       this.reset()
    }

    private findGroupByName(groupName: string): layerGroup {
        let len = this.groups.length

        for (let i = 0; i < len; i++) {
            if (this.groups[i].name === groupName) {
                return this.groups[i]
            }
        }

        return null
    }

    public static get Instance() {
        return this.instance || (this.instance = new this())
    }

    public getLayer(groupName: string): Layer {
        let lGroup = this.findGroupByName(groupName)

        if (lGroup) {
            return this.findGroupByName(groupName).layer
        }

        return null
    }

    public set stage(stage: Stage) {
        this._stage = stage
    }

    public get stage(): Stage {
        return this._stage
    }

    public reset(){
        this.groups = []
        this.groupIndex = 0
    }

    public createGroups(...groups: Array<string>) {
        groups.forEach(group => {
            this.addGroup(group)
        })
    }

    public addGroup(groupName: string, sorting?: boolean | Function) {
        if (!this._stage) {
            throw new Error('Stage not set!')
        }

        let lGroup: layerGroup = new layerGroup()

        if (this.findGroupByName(groupName)) {
            this.warn(`Group ${groupName} already exists!`)

            return
        }

        lGroup.index = this.groupIndex
        lGroup.name = groupName
        lGroup.pixiGroup = new Group(this.groupIndex, sorting)
        lGroup.layer = new Layer(lGroup.pixiGroup)

        this._stage.addChild(lGroup.layer)
        this.groups.push(lGroup)

        this.groupIndex++
    }

    /**
     *
     * @param dObject
     * @param groupName
     * @param recursive
     */
    public addToGroup(dObject: Container, groupName: string | layerGroup, recursive: boolean = false) {
        let group: layerGroup

        if (typeof groupName === 'string') {
            group = this.findGroupByName(groupName)
        } else {
            group = groupName
        }

        if (!group) {
            this.warn(`Group ${groupName} not found!`)

            return
        }

        if (recursive && typeof dObject.children !== 'undefined') {
            dObject.children.forEach(dObject => {
                this.addToGroup(dObject as Container, group)
            })
        }

        dObject.parentGroup = group.pixiGroup
    }

    public addToParentGroup(dObject: Container) {
        let group: Group

        group = dObject.parent.parentGroup

        if (!group) {
            this.warn(`Object's parent does not belong to a Group!`)

            return
        }

        dObject.parentGroup = group
    }

    public setGroupSorting(groupName: string | layerGroup, sorting: boolean | ((...args: any[]) => any)) {
        let group: layerGroup

        if (typeof groupName === 'string') {
            group = this.findGroupByName(groupName)
        } else {
            group = groupName
        }

        if (!group) {
            this.warn(`Group ${groupName} not found!`)

            return
        }

        group.pixiGroup.enableSort = !!sorting
        if (typeof sorting === 'function') {
            group.pixiGroup.on('sort', sorting)
        }
    }
}

const LayerManager = LayerManagerClass.Instance

export { LayerManager }
